<template>
  <section id="header-section">
    <div class="customer-service-header" :class="hidden" v-if="!isLineLoggedIn">
      <div class="row">
        <div class="col-12 p-xl-0 p-sm-2 small">
          Customer Service &nbsp;
          <i class="fas fa-phone"></i>
          <a href="tel:+6621131138">02-113-1138</a>,
          <a href="tel:+66927572999">092-757-2999</a>

          <!-- <div class="line-contact">
            <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img src="/static/img/line-logo.png" style="max-height: 24px;" class="img-fluid" alt="">
              <span>@beneat</span>
            </a>

          </div> -->

        </div>

      </div>
    </div>
    <MenuBar :user="user" 
    :isLineLoggedIn="isLineLoggedIn" 
    :flagImage="flagImage" 
    :hidden="hidden" 
    :hiddenWhenBooking="hiddenWhenBooking"
    :newInbox="newInbox"
    :inboxMessages="inboxMessages"
    :isFetchingMessage="isFetchingMessage"
    :notifications="notifications"
    :isFetchingNoti="isFetchingNoti"
    @openLogoutDialog="$parent.openLogoutDialog"
    @openModal="$parent.openModal($event)"
    @setLocaleLanguage="$parent.setLocaleLanguage($event)"
    @convertUrl="convertUrl($event)"
    @hasReadMessage="hasReadMessage($event)"
    @convertTimespan="convertTimespan($event)"
    @showPicture="showPicture($event)"
    @hasReadActivity="hasReadActivity($event)"
    />
    
    <div class="progress" :class="progressDisplay">
      <div class="progress-bar"
           :style="'width:' + (state.currentStep / 3) * 100 + '%'">
      </div>
    </div>
  </section>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import MenuBar from './materials/MenuBar.vue'

export default {
  components: {
    MenuBar
  },
  data () {
    return {
      noHeaderPaths: ['/promotion', '/promotion-review',
        '/professional-income/:id', '/professional-bonus/:id', '/professional-debt/:id', '/professional-bonus-v2/:id',
        '/cleaner/:id/card', '/subscription-detail', '/recent-reviews',
        '/twitter-campaign', '/facebook-post', '/user/:id/calendar', '/chat-booking', '/article/category', '/article/category/:name',
        '/line-provider/login', '/line-professional/login', '/line-professional/callback', '/invite-friends', '/finnix',
        '/professional/:id/examination', '/professional-questionnaire/:id/test', '/pre-qr-payments', '/job-posts', '/job-posts/:id', '/services/:id',
        '/partners/:id/report', '/professional-login', '/professional-dashboard', '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/inconvenience-maintenance',
        '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/cleaner/:id/contracts/1', '/cleaner/:id/contracts/2',
        '/big-cleaning', '/agency-professional-register', '/user/shipping-address', '/survey-ironing', '/survey-bathroom-cleaning', '/cleaner/:id/consents/1', '/cleaner/consents/1', '/cleaner/:id/consents/2', '/survey/1',
        '/feedback/operation', '/recruitment', '/mikuagency', '/million-booking-celebrate', '/lineman-promotion', '/admin/:id/test/:testId', '/airbnb/login-callback'
      ],
      queryData: {
        page: 0,
        limit: 3,
        dropdown_menu: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      newInbox: 'notification/getNewInbox',
      state: 'booking/getState',
      user: 'auth/getUser'
    }),
    ...mapState('auth', ['isLineLoggedIn']),
    ...mapState({
      notifications: state => state.user.notificationDropdown,
      inboxMessages: state => state.message.inboxMessages,
      isFetchingNoti: state => state.user.isFetchingNoti,
      isFetchingMessage: state => state.message.isFetchingDropdown
    }),
    hidden () {
      return {
        'd-none': (this.noHeaderPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    },
    flagImage () {
      return (this.$i18n.locale === 'en') ? '/static/img/flag-en.jpg' : '/static/img/flag-th.jpg'
    },
    hiddenWhenBooking () {
      return {
        'd-none': (this.$route.matched[0].path === '/booking' || this.isLineLoggedIn)
      }
    },
    progressDisplay () {
      return {
        'd-none': this.$route.matched[0].path !== '/booking'
      }
    }
  },
  methods: {
    updateLocaleLanguage (lang) {
      // console.log('updateLocaleLanguage', lang)
      // this.$parent.setLocaleLangueage(lang)
      this.$i18n.locale = lang
    },
    showPicture (professional) {
      if (professional && professional.picture) {
        return professional.full_picture
      } else {
        return '/static/img/unknown.png'
      }
    },
    convertUrl (chat) {
      if (chat) {
        return `/message?cid=${chat.id}&pid=${chat.professional_id}`
      } else if (chat.last_message.sender_type === 'professional') {
        return `/message?cid=0&pid=${chat.last_message.sender_id}`
      }
    },
    hasReadMessage (message) {
      let recipientType = message.sender_type === 'user' ? 'professional' : 'user'
      let recipientId = 0
      if (message.sender_type === 'professional' && message.chat_room) {
        recipientId = message.chat_room.user_id
      } else if (message.sender_type === 'user' && message.chat_room) {
        recipientId = message.chat_room.professional_id
      }
      this.$store.dispatch('message/SET_MESSAGE_READ_DROPDOWN', {
        recipient_type: recipientType,
        message_id: message.id,
        recipient_id: recipientId
      }).then(res => {
        this.$store.dispatch('notification/LOAD_NOTIFICATIONS', this.user.id)
      })
      window.$('li.dropdown-box').dropdown('hide')
    },
    hasReadActivity (idActivity) {
      // eslint-disable-next-line no-unused-vars
      let { data } = axios.put(`users-activities/${idActivity}/update-is-read`)
        .then(res => {
          this.$store.dispatch('notification/LOAD_NOTIFICATIONS', this.user.id)
        })
      window.$('li.dropdown-box').dropdown('hide')
    },
    convertTimespan (time) {
      return moment(time).fromNow()
    },
    fetchDropdown () {
      this.$store.commit('user/SET_NOTIFICATION_DROPDOWN_LIST', [])
      this.$store.dispatch('user/LOAD_NOTIFICATION_ACTIVITY', this.queryData)
      this.$store.dispatch('message/LOAD_MESSAGE_INBOX', this.queryData)
    },
    handleScroll (event) {
      if (!this.isLineLoggedIn) {
        // ระยะตั้งแต่ navbar ลงไป
        if (window.pageYOffset > 70) {
          window.$('section#header-section').addClass('fixed-top')
        } else {
          window.$('section#header-section').removeClass('fixed-top')
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.$('li.dropdown-box').on('show.bs.dropdown', () => {
        this.fetchDropdown()
      })
    })
  },
  created () {
    if (this.user) {
      this.fetchDropdown()
    }
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

@include media-breakpoint-down(xs) {
  .customer-service-header {
    font-size: 85% !important;
  }
}

@include media-breakpoint-down(sm) {
  .customer-service-header {
    font-size: 90%;

    div.line-contact {
      float: right !important;
    }
  }
}

@include media-breakpoint-up(sm) {
  div.line-contact {
    padding-left: 10px;
  }
}

@include media-breakpoint-up(md) {
  .dropdown-md > .dropdown-menu {
    min-width: 450px;
  }

  div.custom-dropdown {
    right: 10px;
    left: -360px;
    top: 65px;
    border-radius: 0;
  }

  div.head-title {
    margin-top: 12px;

    p {
      font-size: 14px;
      font-weight: 500;
    }

  }

  p.content-box {
    font-size: 16px;
    color: #212529;
  }

}


div.line-contact {
  display: inline-block;
}

.dropdown-item {
  padding: 0.75rem;
  word-wrap: break-word !important;
  width: 100% !important;
  white-space: normal;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #bdbdbd;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
.navbar-blog .router-link-active{
  color: #00B4CD;
  font-weight: 600;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

.user-menu-lg {
  min-width: 260px;
  max-width: 100%;
  max-height: 80vh;
  overflow: auto;
}

.user-menu-md {
  width: 100%;
  overflow: auto;
}

@media (max-width: 500px) {
  .user-menu-md {
    max-height: 200px;
    overflow-y: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue